<div class="subscribe-container" [style.backgroundColor]="backgroundColor" [style.height]="height">
    <div class="content-wrapper">
        <div class="copy-container">
            <p class="eyebrow">{{ content.eyebrow }}</p>
            <h2>{{ displayTitle }}</h2>
            <p class="body-text">{{ displayBody }}</p>
            <p class="current-plan" *ngIf="content.currentPlanLabel">Offre actuelle : {{ content.currentPlanLabel }}</p>
            <div class="benefits-container">
                <div class="benefit-pill" *ngFor="let benefit of displayBenefits">{{ benefit }}</div>
            </div>
            <div class="cta-row">
                <app-button [primary]="true" type="button" (onClick)="goToPricing()">{{ displayPrimaryCtaLabel }}</app-button>
                <a (click)="goToContact()" class="contact-link">{{ displaySecondaryCtaLabel }}</a>
            </div>
        </div>
        <div class="image-wrapper">
            <img class="subscribe-image" src="assets/images/transaction.png" alt="Illustration des offres entreprise We talk">
        </div>
    </div>
</div>
